//  React base styles
import borders from 'assets/theme/base/borders';
import boxShadows from 'assets/theme/base/boxShadows';
import colors from 'assets/theme/base/colors';
import typography from 'assets/theme/base/typography';

//  React helper functions
import pxToRem from 'assets/theme/functions/pxToRem';

const { lg } = boxShadows;
const { size } = typography;
const { text, white, transparent, inputBorderColor } = colors;
const { borderRadius } = borders;

const menu = {
  defaultProps: {
    disableAutoFocusItem: true,
  },

  styleOverrides: {
    root: {
      zIndex: 50010,
    },
    paper: {
      borderRadius: `0 0 ${borderRadius.md} ${borderRadius.md} !important`,
      // minWidth: pxToRem(160),
      boxShadow: lg,
      padding: `${pxToRem(16)} ${pxToRem(8)}`,
      fontSize: size.sm,
      color: text.main,
      textAlign: 'left',
      backgroundColor: `${transparent.blue} !important`,
      // borderRadius: borderRadius.md,
      border: `2px solid ${inputBorderColor}`,
      borderTop: 'none',
    },
  },
};

export default menu;
